import { render, staticRenderFns } from "./updatepwd.vue?vue&type=template&id=455558dc&"
import script from "./updatepwd.vue?vue&type=script&lang=js&"
export * from "./updatepwd.vue?vue&type=script&lang=js&"
import style0 from "./updatepwd.vue?vue&type=style&index=0&id=455558dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports